var currentUserWishlist = [];
var variantButtonAttributes = null;
var completeProductJson = null;

//No products in wishlist markup
var emptyWishlistMarkup = `
  <div class="wishlist_empty">
    <p>Your wishlist is currently empty</p>
    <a class="wishlist_empty_btn btn--dark" href="/">Continue shopping</a>
  </div>`;

//product tile markup
var productCardMarkup = `
   <ul class="wishlist-products">
    <li style="list-style: none">{{#products}}</li>
    <li class="wishlist-product">
      <div>
        <div class="wishlist-image-text">
          <a class="" href="{{du}}"><span class="visually-hidden">{{dt}}</span></a>
          <div class="wishlist-image">
            <div style=""><img class="lazyautosizes" src="{{iu}}"></div>
          </div>
          <div class="wishlist-text">
            <div aria-hidden="true" class="wishlist-title">
              {{dt}}
            </div>
            <dl class="wishlist-price-container" data-price="">
              <dd><span class="wishlist-price" data-sale-price="">{{cu}}{{pr}}</span></dd>
            </dl>
            <div class="wishlist-size">
              <span class="wishlist-size-text">SIZE {{variantinfo}}</span>
              <div class="wishlist-select">
                <a class="change-variant-btn" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}">Edit Product</a>
              </div>
            </div>
          </div>
        </div>
        <div class="wishlist-buttons">
         <a class="add-to-cart btn--dark wishlist-btn wishlist-add" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" href="">{{#isInCart}}Added to bag{{/isInCart}} {{^isInCart}}Add to bag{{/isInCart}}</a>
         <a class="remove-from-cart btn--dark wishlist-btn wishlist-remove" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" href="">Remove</a>
        </div>
      </div>
    </li>
    <li style="list-style: none">{{/products}}</li>
  </ul>`;

// pop-up modal markup.
var variantModalMarkUp = `
<div class="modal" id="modal">
    <div class="modal-background"></div>
    <div class="modal-container">
      <a class="close-button" id="close-button"></a>
      <div class="modal-guts">
        <h1>Select a Size</h1>
        <div class="modal-selects">
           
             <div class="modal-select-container">
               <select class="select-variant-size" id="user-options">
                  <option class="placholder" value="select size">Select Size</option>
               {{#product.variants}}
                  <option class="available-{{available}}" value="{{public_title}}">{{public_title}}</option>
               {{/product.variants}}
               </select> 
             </div>   
           
        </div> 
      </div>
      <div class="action-button-list">
        <a class="save btn--dark wishlist-btn" id="save-button">Save</a> 
        <a class="cancel" id="cancel-button">Cancel</a>
      </div>
    </div>
    <div class="action-button-list">
      <a class="save btn--dark wishlist-btn" id="save-button">Save</a> <a class="cancel" id="cancel-button">Cancel</a>
    </div>
  </div>
    
  </div>`;

// Render the wishlist UI.
function renderWishlistUI() {
  _swat.fetch(function(products) {  
    console.log('rendering wishlist');
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    currentUserWishlist = products;
    var formattedWishlistedProducts = products.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });
    wishlistContentsContainer.innerHTML = (formattedWishlistedProducts.length > 0) ? productCardsMarkup : emptyWishlistMarkup;
    
    var sizeTexts = document.getElementsByClassName("wishlist-size-text");
    
    for (var i = 0; i < sizeTexts.length; i++) {
      var loopId = "size-text-" + [i];
      sizeTexts[i].setAttribute("id", loopId);
    }
   
    getCompleteProductDetails(products, function(completeProducts) {
      
      if(completeProducts.length === products.length) {
        getSavedVariantInfo(products, completeProducts);
      } 
    });
    attachClickListeners();
    
  }, 4);
}

function getSavedVariantInfo(products, completeProducts) {
  var currentEpi, currentVariants, productIndex;
  var productsLength = products.length;
  var wishlistVariants = [];
  
  completeProducts.forEach(function(completeProduct) {
    completeProduct.variants.forEach(function(variant) {
      wishlistVariants.push(variant);
    });
  });
  
    products.forEach(function(product, currentIndex) {
      productIndex = currentIndex;
      currentEpi = product.epi;
      currentVariants = completeProducts[currentIndex].variants
      var productTitle;
      wishlistVariants.forEach(function(wishlistVariant, currentIndex) {
        if(wishlistVariant.id === currentEpi) {
          productTitle = wishlistVariant.title;
          $('#size-text-' + productIndex).html('SIZE ' + productTitle);
        }
      });
    });
  
};



function getCompleteProductDetails(wishlistedProducts, callback) {
  var entireProducts = [];
    wishlistedProducts.forEach(function(product, currentIndex, wishlist) {
      
      var params = {
        epi: product.epi,
        empi: product.empi,
        du: product.du
      };
      const productUrl = product.du
      const productHandle = productUrl.split('products')

      jQuery.getJSON('/products' + productHandle[1] + '.js', function(productJSON) {
        console.log('product json:', productJSON)
        entireProducts.push(productJSON);
        if (entireProducts.length === wishlistedProducts.length) {
          callback(entireProducts); //contains entire product items in your wishlist.
        }
      });
    });
};



function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "Moved to cart";
     window.location.reload();
     console.log("Successfully added product to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}


function attachClickListeners() {
  var editVariantBtns = document.getElementsByClassName("change-variant-btn");
  var addToCartButtons = document.getElementsByClassName("add-to-cart");
  var removeFromCartButtons = document.getElementsByClassName("remove-from-cart");

  for (var i = 0; i < editVariantBtns.length; i++) {
    editVariantBtns[i].addEventListener('click', openVariantSelectionPopUp, false);
  }
   for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
 
  for (var i = 0; i < removeFromCartButtons.length; i++) {
    removeFromCartButtons[i].addEventListener('click', onRemoveClick, false);
  }
}

function openVariantSelectionPopUp(e) {
  completeProductJson = null;
  variantButtonAttributes = null;

  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  var params = {
    du: du,
    empi: parseInt(productId),
    epi: parseInt(variantId)
  };
  
  //   assign the fetched attributes for future use.
  variantButtonAttributes = params;
  window._swat.getProductDetails(params, function(productJson) {
    completeProductJson = productJson;
    renderModalUI(productJson);
  });
}

function renderModalUI(productJson) {
  var modalElem = document.getElementById("modal-overlay");
  var variantMarkUpTemplate = SwymUtils.renderTemplateString(variantModalMarkUp, {
    product: productJson
  });
  modalElem.innerHTML = variantMarkUpTemplate;
  //Attach event listeners to all the buttons in the pop-up.
  attachModalEventListeners();
}

function attachModalEventListeners() {
  var closeButton = document.querySelector("#close-button");
  var cancelButton = document.querySelector("#cancel-button");
  var saveButton = document.querySelector("#save-button");
  //   close btn
  closeButton.addEventListener("click", function() {
    document.getElementById('modal').classList.toggle("closed");
  });
  //   cancel button.
  cancelButton.addEventListener("click", function() {
    document.getElementById('modal').classList.toggle("closed");
  });
  saveButton.addEventListener("click", function() {
    saveSelection();
    //     Close the modal after save. 
    var selectedOption = $('#user-options option:selected').val();
    
    if(selectedOption != 'select size') {
      document.getElementById('modal').classList.toggle("closed");
    }
  });
}

function saveSelection() {
  var selectedOption = $('#user-options option:selected').val();
  
  if(selectedOption != 'select size') {
    var userSelectionData = getSelectTagValues("#user-options");
    var variant = findVariant(userSelectionData);
    removeProductFromWishlistWithoutReload(variantButtonAttributes, function(removedProduct) {
      var newProductVariantAttributes = {
        empi: removedProduct.empi,
        epi: variant.id,
        du: removedProduct.du
      }
      addProductToWishlist(newProductVariantAttributes);
    });
  } else {
    $('#save-button').text('Please select a size');
  }
  
}
// Helper function
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// Finds the correct variant object based on the user input in the modal.
function findVariant(userSelectedOption) {
  var keys = Object.keys(userSelectedOption).filter(function(key) {
    return userSelectedOption[key] !== null && userSelectedOption[key] !== undefined;
  });
  var match = completeProductJson.variants.find(function(variant) {
    return keys.every(function(key, value) {
      return (variant[key] === userSelectedOption[key] && variant[value] === userSelectedOption[value]);
    });
  });
  return match;
}
//fetch the user selected value from the modal.
function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var fullOptions = $(selector).val();
    var elemNode = fullOptions.split(" / ");
    for (var i = 0; i < elemNode.length; i++) {
      var optionValue = elemNode[i];
      var key = "option" + (i + 1);
      var selectedValueObj = _defineProperty({}, key, optionValue);
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    }
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}


function onRemoveClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  getProductObject({empi: productId, epi : variantId}, function(completeProductObj){
    removeFromWishlist(completeProductObj);
  });
}
// normal remove function.
function removeFromWishlist(product, callback){
  window._swat.removeFromWishList(product, function(r){
    console.log('Removed from wishlist', r);
    //     Reload or re-render as required.
    window.location.reload();
  })
}

//remove without reload.
function removeProductFromWishlistWithoutReload(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function(r) {
    console.log("Removing current Variant")
    callback(r);
  });
}


function getProductObject (productParams, successCallBackFn){
  for(var i=0; i < currentUserWishlist.length; i++ ){
    if(currentUserWishlist[i].empi == productParams.empi && 
       currentUserWishlist[i].epi == productParams.epi){
      successCallBackFn(currentUserWishlist[i]);
    }
  }
}


function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function(r) {
    //       Added and re-render the Ui To reflect.
    renderWishlistUI();
  });
}

function swymCallbackFn() {
  renderWishlistUI();
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
